import type { CSSProperties, ImgHTMLAttributes } from 'react';
import { normalizeStyle } from './normalizeStyle';

import ActionSmallBankUrl from './action-small-bank-default.svg';
import ActionSmallCalendarUrl from './action-small-calendar-default.svg';
import ActionSmallCloseDefaultUrl from './action-small-close-default.svg';
import ActionSmallEditUrl from './action-small-edit-default.svg';
import ActionSmallEllipsisUrl from './action-small-ellipsis-default.svg';
import ActionSmallEnvelopeTertiaryDefaultUrl from './action-small-envelope-tertiary-default.svg';
import ActionSmallExportDefaultUrl from './action-small-export-default.svg';
import ActionSmallFilterUrl from './action-small-filter-default.svg';
import ActionSmallGripUrl from './action-small-grip-default.svg';
import ActionSmallMenuCloseUrl from './action-small-menu-close.svg';
import ActionSmallPhone2TertiaryDefaultUrl from './action-small-phone-2-tertiary-default.svg';
import ActionSmallPlusUrl from './action-small-plus-default.svg';
import ActionSmallPlusDisabledUrl from './action-small-plus-disabled.svg';
import ActionSmallScrollToBottomUrl from './action-small-scroll-to-bottom.svg';
import ActionSmallSignOutTertiaryUrl from './action-small-sign-out-tertiary.svg';
import ActionAdviceIconDefaultUrl from './action-tab-bar-advice-icon-only-default.svg';
import ActionBudgetIconDefaultUrl from './action-tab-bar-budget-icon-only-default.svg';
import ActionGoalsIconDefaultUrl from './action-tab-bar-goals-icon-only-default.svg';
import ActionNetWorthIconDefaultUrl from './action-tab-bar-net-worth-icon-only-default.svg';
import ActionToolsIconDefaultUrl from './action-tab-bar-tools-icon-only-default.svg';
import AppleLogoWhiteUrl from './apple-logo-white.svg';
import ArrowUrl from './arrow.svg';
import ArtAdviceUrl from './art-advice.svg';
import ArtApprovedUrl from './art-approved.svg';
import ArtBooksUrl from './art-books.svg';
import ArtBrainFogUrl from './art-brain-fog.svg';
import ArtBusinessUrl from './art-business.svg';
import ArtCarUrl from './art-car.svg';
import ArtCar1Url from './art-car-1.svg';
import ArtCar2Url from './art-car-2.svg';
import ArtCarouselBeachChairUrl from './art-carousel-beach-chair.svg';
import ArtCarouselBusinessUrl from './art-carousel-business.svg';
import ArtCarouselCarUrl from './art-carousel-car.svg';
import ArtCarouselCoinsDownUrl from './art-carousel-coins-down.svg';
import ArtCarouselCoinsSameUrl from './art-carousel-coins-same.svg';
import ArtCarouselCoinsUpUrl from './art-carousel-coins-up.svg';
import ArtCarouselCollegeUrl from './art-carousel-college.svg';
import ArtCarouselCompassUrl from './art-carousel-compass.svg';
import ArtCarouselCreditCardUrl from './art-carousel-credit-card.svg';
import ArtCarouselGiftsUrl from './art-carousel-gifts.svg';
import ArtCarouselGifts2Url from './art-carousel-gifts-2.svg';
import ArtCarouselGuitarUrl from './art-carousel-guitar.svg';
import ArtCarouselHouseUrl from './art-carousel-house.svg';
import ArtCarouselLoanUrl from './art-carousel-loan.svg';
import ArtCarouselMedicalUrl from './art-carousel-medical.svg';
import ArtCarouselPaintbrushUrl from './art-carousel-paintbrush.svg';
import ArtCarouselPoolUrl from './art-carousel-pool.svg';
import ArtCarouselSailboatUrl from './art-carousel-sailboat.svg';
import ArtCarouselShoppingUrl from './art-carousel-shopping.svg';
import ArtCarouselWeddingUrl from './art-carousel-wedding.svg';
import ArtCarouselWheelBarrowUrl from './art-carousel-wheel-barrow.svg';
import ArtCardBeachChairUrl from './art-card-beach-chair.svg';
import ArtCardBondsUrl from './art-card-bonds.svg';
import ArtCardCashUrl from './art-card-cash.svg';
import ArtCardClockUrl from './art-card-clock.svg';
import ArtCardCreditCardUrl from './art-card-credit-card.svg';
import ArtCardDebtUrl from './art-card-debt.svg';
import ArtCardMoneyUrl from './art-card-money.svg';
import ArtCardPiggyBankUrl from './art-card-piggy-bank.svg';
import ArtCardStocksUrl from './art-card-stocks.svg';
import ArtCardTargetUrl from './art-card-target.svg';
import ArtCellPhoneUrl from './art-cell-phone.svg';
import ArtChipCalculatorUrl from './art-chip-calculator.svg';
import ArtChipCollegeUrl from './art-chip-college.svg';
import ArtChipCreditCardUrl from './art-chip-credit-card.svg';
import ArtChipPieChartUrl from './art-chip-pie-chart.svg';
import ArtCoffeeUrl from './art-coffee.svg';
import ArtCollegeGradCapUrl from './art-college-grad-cap.svg';
import ArtComprehensiveInsuranceUrl from './art-comprehensive-insurance.svg';
import ArtConfusedManUrl from './art-confused-man.svg';
import ArtCreditCardUrl from './art-credit-card.svg';
import ArtCreditCard2Url from './art-credit-card-2.svg';
import ArtCreditCard3Url from './art-credit-card-3.svg';
import ArtCreditScoreUrl from './art-credit-score.svg';
import ArtDashboardChecklistUrl from './art-dashboard-checklist.svg';
import ArtDashboardLightbulbUrl from './art-dashboard-lightbulb.svg';
import ArtDashboardMagnifyingGlassUrl from './art-dashboard-magnifying-glass.svg';
import ArtDebtSmallUrl from './art-debt-small.svg';
import ArtDebtUrl from './art-debt.svg';
import ArtDonationUrl from './art-donation.svg';
import ArtGivingCollegeUrl from './art-giving-college.svg';
import ArtGivingHeart2Url from './art-giving-heart-2.svg';
import ArtHandClapUrl from './art-hand-clap.svg';
import ArtHandshakeUrl from './art-handshake.svg';
import ArtHealthInsuranceUrl from './art-health-insurance.svg';
import ArtHealthInsurance2Url from './art-health-insurance-2.svg';
import ArtHeartUrl from './art-giving-heart.svg';
import ArtHouseUrl from './art-house.svg';
import ArtHouseKeysUrl from './art-house-keys.svg';
import ArtHouseLargeUrl from './art-house-large.svg';
import ArtInvestmentDataUrl from './art-investment-data.svg';
import ArtLaptopLargeUrl from './art-laptop-large.svg';
import ArtLaptopUrl from './art-laptop.svg';
import ArtLifestyleUrl from './art-lifestyle.svg';
import ArtLightbulbLargeUrl from './art-lightbulb-large.svg';
import ArtLightbulbMediumUrl from './art-lightbulb-medium.svg';
import ArtLightbulbSmallUrl from './art-lightbulb-small.svg';
import ArtMagnifyingGlassUrl from './art-magnifying-glass.svg';
import ArtMedicalSuppliesUrl from './art-medical-supplies.svg';
import ArtMeditationUrl from './art-meditation.svg';
import ArtMoneyLargeUrl from './art-money-large.svg';
import ArtMoneyPlantUrl from './art-money-plant.svg';
import ArtMoneySmallUrl from './art-money-small.svg';
import ArtOrganizationUrl from './art-organization.svg';
import ArtPieChartUrl from './art-pie-chart.svg';
import ArtPieChartLargeUrl from './art-pie-chart-large.svg';
import ArtPiggyBankUrl from './art-piggy-bank.svg';
import ArtPiggyBank2Url from './art-piggy-bank-2.svg';
import ArtPiggyBank3Url from './art-piggy-bank-3.svg';
import ArtPlantUrl from './art-plant.svg';
import ArtPresentsUrl from './art-presents.svg';
import ArtQuestionUrl from './art-question.svg';
import ArtRetirementUrl from './art-retirement.svg';
import ArtRetirementLargeUrl from './art-retirement-large.svg';
import ArtRetirementSmallUrl from './art-retirement-small.svg';
import ArtRibbonUrl from './art-ribbon.svg';
import ArtStudyMaterialsUrl from './art-study-materials.svg';
import ArtTargetUrl from './art-target.svg';
import ArtTargetSmallUrl from './art-target-small.svg';
import ArtThumbsUpUrl from './art-thumbs-up.svg';
import ArtTrophySmall2Url from './art-trophy-small-2.svg';
import ArtUmbrella2Url from './art-umbrella-2.svg';
import ArtUmbrellaUrl from './art-umbrella.svg';
import ArtUni3NUrl from './art-uni-3n.svg';
import BeachChairUrl from './beach-chair.svg';
import BulletBookUrl from './bullet-book.svg';
import BulletCalculatorUrl from './bullet-calculator.svg';
import BulletChecklistUrl from './bullet-checklist.svg';
import BulletCoachUrl from './bullet-coach.svg';
import BulletInvestmentGCUrl from './bullet-investment-gc.svg';
import BulletInvestmentUrl from './bullet-investment.svg';
import BulletLessonsUrl from './bullet-lessons.svg';
import BulletLoansUrl from './bullet-loans.svg';
import BulletPiggyBankUrl from './bullet-piggy-bank.svg';
import BulletPiggyBankGcUrl from './bullet-piggy-bank-gc.svg';
import BulletQaUrl from './bullet-qa.svg';
import BulletStatisticsUrl from './bullet-statistics.svg';
import CarUrl from './car.svg';
import CardGradientUrl from './card-gradient.svg';
import CashUrl from './cash.svg';
import CollegeGradCapUrl from './college-grad-cap.svg';
import ConfettiUrl from './confetti.svg';
import DebtUrl from './debt.svg';
import DisplayExtraSmallCustomCheckmarkUrl from './display-extra-small-custom-checkmark.svg';
import DisplayExtraSmallCustomXUrl from './display-extra-small-custom-x.svg';
import DisplayHamburgerMenuChatPrimaryUrl from './display-hamburger-menu-chat-primary.svg';
import DisplayHamburgerMenuChatSecondaryUrl from './display-hamburger-menu-chat-secondary.svg';
import DisplayHamburgerMenuPremiumUrl from './display-hamburger-menu-premium.svg';
import DisplayHamburgerMenuSignOutUrl from './display-hamburger-menu-sign-out.svg';
import DisplayHamburgerMenuSignOutPrimaryUrl from './display-hamburger-menu-sign-out-primary.svg';
import DisplayHamburgerMenuHeadsetUrl from './display-hamburger-menu-headset.svg';
import DisplayHamburgerMenuHeadsetPrimaryUrl from './display-hamburger-menu-headset-primary.svg';
import DisplayLargeCustomCheckmarkUrl from './display-large-custom-checkmark.svg';
import DisplayLargeCustomClockUrl from './display-large-custom-clock.svg';
import DisplayLargeCustomCollision3Url from './display-large-custom-collision-3.svg';
import DisplayLargeCustomHomeOfferUrl from './display-large-custom-home-offer.svg';
import DisplayLargeCustomHomeSaleUrl from './display-large-custom-home-sale.svg';
import DisplayLargeCustomHouseUrl from './display-large-custom-house.svg';
import DisplayLargeCustomLegalDocsUrl from './display-large-custom-legal-docs.svg';
import DisplayLargeCustomMedicalUrl from './display-large-custom-medical.svg';
import DisplayLargeCustomMoneyBagUrl from './display-large-custom-money-bag.svg';
import DisplayLargeCustomMoneyExchangeUrl from './display-large-custom-money-exchange.svg';
import DisplayLargeCustomPaintRollerUrl from './display-large-custom-paint-roller.svg';
import DisplayLargeCustomRetirementUrl from './display-large-custom-retirement.svg';
import DisplayLargeCustomSaleProceedsUrl from './display-large-custom-sale-proceeds.svg';
import DisplayLargeCustomScaleUrl from './display-large-custom-scale.svg';
import DisplayLargeCustomTaxUrl from './display-large-custom-tax.svg';
import DisplayLargeCustomWarningUrl from './display-large-custom-warning.svg';
import DisplayLargeCustomWarningErrorBaseUrl from './display-large-custom-warning-errorBase.svg';
import DisplayMediumCustomBirthdayCakeUrl from './display-medium-custom-birthday-cake.svg';
import DisplayMediumCustomBriefcasePrimaryUrl from './display-medium-custom-briefcase-primary.svg';
import DisplayMediumCustomBriefcaseUrl from './display-medium-custom-briefcase.svg';
import DisplayMediumCustomBusUrl from './display-medium-custom-bus.svg';
import DisplayMediumCustomCancelUrl from './display-medium-custom-cancel.svg';
import DisplayMediumCustomCarUrl from './display-medium-custom-car.svg';
import DisplayMediumCustomCarSecondaryUrl from './display-medium-custom-car-secondary.svg';
import DisplayMediumCustomCautionUrl from './display-medium-custom-caution.svg';
import DisplayMediumCustomCellPhoneUrl from './display-medium-custom-cell-phone.svg';
import DisplayMediumCustomCoffeeUrl from './display-medium-custom-coffee.svg';
import DisplayMediumCustomCreditCardUrl from './display-medium-custom-credit-card.svg';
import DisplayMediumCustomGenderUrl from './display-medium-custom-gender.svg';
import DisplayMediumCustomGlassUrl from './display-medium-custom-glass.svg';
import DisplayMediumCustomHandshakeUrl from './display-medium-custom-handshake.svg';
import DisplayMediumCustomHeartUrl from './display-medium-custom-heart.svg';
import DisplayMediumCustomLightbulbUrl from './display-medium-custom-lightbulb.svg';
import DisplayMediumCustomLocationUrl from './display-medium-custom-location.svg';
import DisplayMediumCustomPlaneUrl from './display-medium-custom-plane.svg';
import DisplayMediumCustomReceiptUrl from './display-medium-custom-receipt.svg';
import DisplayMediumCustomRibbonUrl from './display-medium-custom-ribbon.svg';
import DisplayMediumCustomShoppingCartUrl from './display-medium-custom-shopping-cart.svg';
import DisplayMediumCustomSpeedometerUrl from './display-medium-custom-speedometer.svg';
import DisplayMediumCustomTVUrl from './display-medium-custom-tv.svg';
import DisplayMediumCustomUmbrellaUrl from './display-medium-custom-umbrella.svg';
import DisplayMediumPrimaryAnotherBehalfUrl from './display-medium-primary-another-behalf.svg';
import DisplayMediumPrimaryBudgetUrl from './display-medium-primary-budget.svg';
import DisplayMediumPrimaryCarUrl from './display-medium-primary-car.svg';
import DisplayMediumPrimaryCoinsUrl from './display-medium-primary-coins.svg';
import DisplayMediumPrimaryCoinStackUrl from './display-medium-custom-coin-stack.svg';
import DisplayMediumPrimaryCollegeUrl from './display-medium-primary-college.svg';
import DisplayMediumPrimaryCreditCardUrl from './display-medium-primary-credit-card.svg';
import DisplayMediumPrimaryDebtUrl from './display-medium-primary-debt.svg';
import DisplayMediumPrimaryGiftsUrl from './display-medium-primary-gifts.svg';
import DisplayMediumPrimaryGoalsUrl from './display-medium-primary-goals.svg';
import DisplayMediumPrimaryHouseUrl from './display-medium-primary-house.svg';
import DisplayMediumPrimaryInvestmentUrl from './display-medium-primary-investment.svg';
import DisplayMediumPrimaryLegacyUrl from './display-medium-primary-legacy.svg';
import DisplayMediumPrimaryLoansUrl from './display-medium-primary-loans.svg';
import DisplayMediumPrimaryMedicalUrl from './display-medium-primary-medical.svg';
import DisplayMediumPrimaryPiggyBankUrl from './display-medium-primary-piggy-bank.svg';
import DisplayMediumPrimaryPlaneUrl from './display-medium-primary-plane.svg';
import DisplayMediumPrimaryRetirementUrl from './display-medium-primary-retirement.svg';
import DisplayMediumPrimaryTaxUrl from './display-medium-primary-tax.svg';
import DisplayMediumPrimaryTimeUrl from './display-medium-primary-time.svg';
import DisplayMediumPrimaryUmbrellaUrl from './display-medium-primary-umbrella.svg';
import DisplaySmallCreditCardGrayFilledUrl from './display-small-credit-card-gray-filled.svg';
import DisplaySmallCreditCardPrimaryBaseFilledUrl from './display-small-credit-card-primary-base-filled.svg';
import DisplaySmallCreditCardPrimaryLightFilledUrl from './display-small-credit-card-primary-light-filled.svg';
import DisplaySmallCreditCardPrimaryLightOutlinedUrl from './display-small-credit-card-primary-light-outlined.svg';
import DisplaySmallCustomAdviceUrl from './display-small-custom-advice.svg';
import DisplaySmallCustomAlertsUrl from './display-small-custom-alerts.svg';
import DisplaySmallCustomBirthdayCakeUrl from './display-small-custom-birthday-cake.svg';
import DisplaySmallCustomBookUrl from './display-small-custom-book.svg';
import DisplaySmallCustomBankUrl from './display-small-custom-bank.svg';
import DisplaySmallCustomBudgetUrl from './display-small-custom-budget.svg';
import DisplaySmallCustomBriefcaseUrl from './display-small-custom-briefcase.svg';
import DisplaySmallCustomBudget2Url from './display-small-custom-budget-2.svg';
import DisplaySmallCustomCalculatorUrl from './display-small-custom-calculator.svg';
import DisplaySmallCustomCalendarUrl from './display-small-custom-calendar.svg';
import DisplaySmallCustomCarUrl from './display-small-custom-car.svg';
import DisplaySmallCustomChatUrl from './display-small-custom-chat.svg';
import DisplaySmallCustomChatActiveUrl from './display-small-custom-chat-active.svg';
import DisplaySmallCustomChecklistUrl from './display-small-custom-checklist.svg';
import DisplaySmallCustomCheckmarkFilledUrl from './display-small-custom-checkmark-filled.svg';
import DisplaySmallCustomCheckmarkUrl from './display-small-custom-checkmark.svg';
import DisplaySmallCustomClockUrl from './display-small-custom-clock.svg';
import DisplaySmallCustomCoinsUrl from './display-small-custom-coins.svg';
import DisplaySmallCustomCollisionUrl from './display-small-custom-collision.svg';
import DisplaySmallCustomCreditCardUrl from './display-small-custom-credit-card.svg';
import DisplaySmallCustomCreditCardPrimaryUrl from './display-small-custom-credit-card-primary.svg';
import DisplaySmallCustomCreditCard2Url from './display-small-custom-credit-card-2.svg';
import DisplaySmallCustomCreditCard3Url from './display-small-custom-credit-card-3.svg';
import DisplaySmallCustomDepositUrl from './display-small-custom-deposit.svg';
import DisplaySmallCustomDebtUrl from './display-small-custom-debt.svg';
import DisplaySmallCustomDebt2Url from './display-small-custom-debt-2.svg';
import DisplaySmallCustomDocUploadUrl from './display-small-custom-doc-upload.svg';
import DisplaySmallCustomEnvelopeUrl from './display-small-custom-envelope.svg';
import DisplaySmallCustomFaxUrl from './display-small-custom-fax.svg';
import DisplaySmallCustomFoodUrl from './display-small-custom-food.svg';
import DisplaySmallCustomFoodYellowUrl from './display-small-custom-food-yellow.svg';
import DisplaySmallCustomFunnelUrl from './display-small-custom-funnel.svg';
import DisplaySmallCustomGiftsUrl from './display-small-custom-gifts.svg';
import DisplaySmallCustomGiftsPrimaryUrl from './display-small-custom-gifts-primary.svg';
import DisplaySmallCustomGoalsUrl from './display-small-custom-goals.svg';
import DisplaySmallCustomGoals2Url from './display-small-custom-goals-2.svg';
import DisplaySmallCustomHandshakeUrl from './display-small-custom-handshake.svg';
import DisplaySmallCustomHealthInsuranceUrl from './display-small-custom-health-insurance.svg';
import DisplaySmallCustomHeyNicUrl from './display-small-custom-hey-nic.svg';
import DisplaySmallCustomHomeSaleUrl from './display-small-custom-home-sale.svg';
import DisplaySmallCustomHouseUrl from './display-small-custom-house.svg';
import DisplaySmallCustomHouseAffordUrl from './display-small-custom-house-afford.svg';
import DisplaySmallCustomHouseKeysUrl from './display-small-custom-house-keys.svg';
import DisplaySmallCustomInfoUrl from './display-small-custom-info.svg';
import DisplaySmallCustomInstitutionUrl from './display-small-custom-institution.svg';
import DisplaySmallCustomInvestmentUrl from './display-small-custom-investment.svg';
import DisplaySmallCustomInvestment2Url from './display-small-custom-investment-2.svg';
import DisplaySmallCustomItemizationUrl from './display-small-custom-itemization.svg';
import DisplaySmallCustomLegacyUrl from './display-small-custom-legacy.svg';
import DisplaySmallCustomLightBulbUrl from './display-small-custom-lightbulb.svg';
import DisplaySmallCustomLinkAccountUrl from './display-small-custom-link-account.svg';
import DisplaySmallCustomLoansUrl from './display-small-custom-loans.svg';
import DisplaySmallCustomLoansSecondaryUrl from './display-small-custom-loans-secondary.svg';
import DisplaySmallCustomLockUrl from './display-small-custom-lock.svg';
import DisplaySmallCustomLockGrayUrl from './display-small-custom-lock-gray.svg';
import DisplaySmallCustomMarketplaceUrl from './display-small-custom-marketplace.svg';
import DisplaySmallCustomMedicalUrl from './display-small-custom-medical.svg';
import DisplaySmallCustomMedicalUmbrellaUrl from './display-small-custom-medical-umbrella.svg';
import DisplaySmallCustomMembersUrl from './display-small-custom-members.svg';
import DisplaySmallCustomOnTargetUrl from './display-small-custom-on-target.svg';
import DisplaySmallCustomOrganizationUrl from './display-small-custom-organization.svg';
import DisplaySmallCustomPayOffUrl from './display-small-custom-pay-off.svg';
import DisplaySmallCustomPercentUrl from './display-small-custom-percent.svg';
import DisplaySmallCustomPhone2Url from './display-small-custom-phone-2.svg';
import DisplaySmallCustomPiggyBankUrl from './display-small-custom-piggy-bank.svg';
import DisplaySmallCustomPlanUrl from './display-small-custom-plan.svg';
import DisplaySmallCustomProfileActiveUrl from './display-small-custom-profile-active.svg';
import DisplaySmallCustomProfileDefaultUrl from './display-small-custom-profile-default.svg';
import DisplaySmallCustomProgressCompleteUrl from './display-small-custom-progress-complete.svg';
import DisplaySmallCustomPromotionsUrl from './display-small-custom-promotions.svg';
import DisplaySmallCustomRentOrBuyUrl from './display-small-custom-rent-vs-buy.svg';
import DisplaySmallCustomRetirementUrl from './display-small-custom-retirement.svg';
import DisplaySmallCustomScaleUrl from './display-small-custom-scale.svg';
import DisplaySmallCustomSearchUrl from './display-small-custom-search.svg';
import DisplaySmallCustomShieldUrl from './display-small-custom-shield.svg';
import DisplaySmallCustomShoppingCartUrl from './display-small-custom-shopping-cart.svg';
import DisplaySmallCustomStatisticsUrl from './display-small-custom-statistics.svg';
import DisplaySmallCustomTaxUrl from './display-small-custom-tax.svg';
import DisplaySmallCustomThumbsDownUrl from './display-small-custom-thumbs-down.svg';
import DisplaySmallCustomThumbsUpUrl from './display-small-custom-thumbs-up.svg';
import DisplaySmallCustomToolsUrl from './display-small-custom-tools.svg';
import DisplaySmallCustomUmbrellaUrl from './display-small-custom-umbrella.svg';
import DisplaySmallCustomVacationUrl from './display-small-custom-vacation.svg';
import DisplaySmallCustomVideoCameraUrl from './display-small-custom-video-camera.svg';
import DisplaySmallCustomWalletUrl from './display-small-custom-wallet.svg';
import DisplaySmallCustomWalletPrimaryUrl from './display-small-custom-wallet-primary.svg';
import DisplaySmallCustomWarningUrl from './display-small-custom-warning.svg';
import DisplaySmallCustomXFilledUrl from './display-small-custom-x-filled.svg';
import DisplaySmallPrimaryLightBookUrl from './display-small-primary-light-book.svg';
import DisplaySmallPrimaryLightLockUrl from './display-small-primary-light-lock.svg';
import DisplaySmallSecondaryBasePiggyBankUrl from './display-small-secondary-base-piggy-bank.svg';
import DisplaySmallWhiteBankUrl from './display-small-white-bank.svg';
import DisplaySmallWhiteBookUrl from './display-small-white-book.svg';
import DisplaySmallWhiteBudgetUrl from './display-small-white-budget.svg';
import DisplaySmallWhiteCarUrl from './display-small-white-car.svg';
import DisplaySmallWhiteCoinsUrl from './display-small-white-coins.svg';
import DisplaySmallWhiteCollegeUrl from './display-small-white-college.svg';
import DisplaySmallWhiteDepositUrl from './display-small-white-deposit.svg';
import DisplaySmallWhiteFoodUrl from './display-small-white-food.svg';
import DisplaySmallWhiteHandshakeUrl from './display-small-white-handshake.svg';
import DisplaySmallWhiteHealthInsuranceUrl from './display-small-white-health-insurance.svg';
import DisplaySmallWhiteHouseUrl from './display-small-white-house.svg';
import DisplaySmallWhiteItemizationUrl from './display-small-white-itemization.svg';
import DisplaySmallWhiteLegacyUrl from './display-small-white-legacy.svg';
import DisplaySmallWhiteLightBulbUrl from './display-small-white-lightbulb.svg';
import DisplaySmallWhiteLoansUrl from './display-small-white-loans.svg';
import DisplaySmallWhiteMedicalUrl from './display-small-white-medical.svg';
import DisplaySmallWhiteMembersUrl from './display-small-white-members.svg';
import DisplaySmallWhitePlanUrl from './display-small-white-plan.svg';
import DisplaySmallWhiteRetirementUrl from './display-small-white-retirement.svg';
import DisplaySmallWhiteShoppingCartUrl from './display-small-white-shopping-cart.svg';
import DisplaySmallWhiteVacationUrl from './display-small-white-vacation.svg';
import DisplaySmallWhiteVideoCameraUrl from './display-small-white-video-camera.svg';
import DisplaySmallWhiteWalletUrl from './display-small-white-wallet.svg';
import DisplaySmallWhiteWithdrawUrl from './display-small-white-withdraw.svg';
import DownArrowSecondaryUrl from './down-arrow-secondary.svg';
import GivingHeartUrl from './giving-heart.svg';
import HouseUrl from './house.svg';
import DisplaySmallCustomWithdrawUrl from './display-small-custom-withdraw.svg';
import Icon3NUCoachUrl from './icon-3nu-coach.svg';
import Icon3NULessonsUrl from './icon-3nu-lessons.svg';
import Icon3NUQaUrl from './icon-3nu-qa.svg';
import IconAddUrl from './icon-add.svg';
import IconAdminsActiveUrl from './icon-admins-active.svg';
import IconAdminsDefaultUrl from './icon-admins-default.svg';
import IconArrowDownUrl from './icon-arrow-down.svg';
import IconArrowLeftUrl from './icon-arrow-left.svg';
import IconArrowLeftDisabledUrl from './icon-arrow-left-disabled.svg';
import IconArrowRightUrl from './icon-arrow-right.svg';
import IconArrowRightDisabledUrl from './icon-arrow-right-disabled.svg';
import IconArrowRightWhiteUrl from './icon-arrow-right-white.svg';
import IconBookUrl from './icon-book.svg';
import IconCalculatorUrl from './icon-calculator.svg';
import IconChatUrl from './icon-chat.svg';
import IconChecklistUrl from './icon-checklist.svg';
import IconCheckmarkUrl from './icon-checkmark.svg';
import IconCheckmarkGreenUrl from './icon-checkmark-green.svg';
import IconCloseUrl from './icon-close.svg';
import IconCollapseUrl from './icon-collapse.svg';
import IconCollege2Url from './icon-college-2.svg';
import IconCollegeUrl from './icon-college.svg';
import IconCommunicationsActiveUrl from './icon-communications-active.svg';
import IconCommunicationsDefaultUrl from './icon-communications-default.svg';
import IconContactUsActiveUrl from './icon-contact-us-active.svg';
import IconContactUsDefaultUrl from './icon-contact-us-default.svg';
import IconDashboardActiveUrl from './icon-dashboard-active.svg';
import IconDashboardDefaultUrl from './icon-dashboard-default.svg';
import IconDeleteUrl from './icon-delete.svg';
import IconDownloadPrimaryBaseUrl from './icon-download-primary-base.svg';
import IconDownloadUrl from './icon-download.svg';
import IconEditUrl from './icon-edit.svg';
import IconExitUrl from './icon-exit.svg';
import IconExpandUrl from './icon-expand.svg';
import IconGripUrl from './icon-grip.svg';
import IconHouseActiveUrl from './icon-house-active.svg';
import IconHouseDefaultUrl from './icon-house-default.svg';
import IconInvestmentUrl from './icon-investment.svg';
import IconLicenseActiveUrl from './icon-license-active.svg';
import IconLicenseDefaultUrl from './icon-license-default.svg';
import IconMembersActiveUrl from './icon-members-active.svg';
import IconMembersDefaultWhiteUrl from './icon-members-default-white.svg';
import IconMembersDefaultUrl from './icon-members-default.svg';
import IconMembersLargeUrl from './icon-members-large.svg';
import IconMinimizeUrl from './icon-minimize.svg';
import IconNavAlertDefaultUrl from './icon-nav-alert-default.svg';
import IconNavMenuDefaultUrl from './icon-nav-menu-default.svg';
import IconOrganizationUrl from './icon-organization.svg';
import IconOrgPaysLargeUrl from './icon-org-pays-large.svg';
import IconOrgPaysTertiaryUrl from './icon-org-pays-tertiary.svg';
import IconPaymentActiveUrl from './icon-payment-active.svg';
import IconPaymentDefaultUrl from './icon-payment-default.svg';
import IconProfileUrl from './icon-profile.svg';
import IconSearchUrl from './icon-search.svg';
import IconStepperUrl from './icon-stepper.svg';
import IconWarningUrl from './icon-warning.svg';
import IpmIconDeleteUrl from './ipm-icon-delete.svg';
import IpmIconDownloadUrl from './ipm-icon-download.svg';
import LinkPaperClipUrl from './link-paperclip.svg';
import LogoHeyNicIconOnlyUrl from './logo-hey-nic-icon-only.svg';
import LogoTextSecondaryUnregisteredUrl from './logo-text-secondary-unregistered.svg';
import LogoTithelyIconOnlyUrl from './logo-tithe-ly-icon-only.svg';
import LogoTithelyUrl from './logo-tithe-ly.svg';
import NickelsULogoSecondaryUrl from './3nu-logo-secondary.svg';
import PiggyBankUrl from './piggy-bank.svg';
import PresentsUrl from './presents.svg';
import RibbonUrl from './ribbon.svg';
import SendArrowUrl from './send_arrow.svg';
import UmbrellaUrl from './umbrella.svg';
import WebIconGripUrl from './web-icon-grip.svg';
import WebIconOrganizationUrl from './web-icon-organization.svg';
import WebIconRefreshUrl from './web-icon-refresh.svg';

type SvgProps = Record<string, unknown> & {
  title?: string;
  opacity?: number | string;
  className?: string;
  style?: CSSProperties;
  alt?: string;
  width?: number | string;
  height?: number | string;
};

const makeSvg = (name: string, src: string) => {
  const Svg = (rawProps: SvgProps) => {
    const {
      title,
      alt,
      className,
      opacity,
      style,
      width,
      height,
      onClick,
      onMouseEnter,
      onMouseLeave,
      onMouseDown,
      onMouseUp,
      onKeyDown,
      onKeyUp,
      onFocus,
      onBlur,
      role,
      tabIndex,
      id,
      loading,
      decoding,
      ref: svgRef,
      ...rest
    } = rawProps as SvgProps & { ref?: unknown };
    void svgRef;

    const passThrough: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(rest)) {
      if (key.startsWith('data-') || key.startsWith('aria-')) {
        passThrough[key] = value;
      }
      if (key.startsWith('on') && typeof value === 'function') {
        passThrough[key] = value;
      }
    }

    // Treat width/height like the old inline-SVG sizing behavior (CSS lengths),
    // not numeric <img width/height> attributes.
    const imgStyle: CSSProperties = {
      ...normalizeStyle(style),
      ...(opacity !== undefined ? { opacity } : {}),
      ...(width !== undefined ? { width } : {}),
      ...(height !== undefined ? { height } : {}),
    };

    return (
      <img
        src={src}
        alt={alt ?? title ?? ''}
        className={className ? `svg-img ${className}` : 'svg-img'}
        style={imgStyle}
        onClick={onClick as ImgHTMLAttributes<HTMLImageElement>['onClick']}
        onMouseEnter={onMouseEnter as ImgHTMLAttributes<HTMLImageElement>['onMouseEnter']}
        onMouseLeave={onMouseLeave as ImgHTMLAttributes<HTMLImageElement>['onMouseLeave']}
        onMouseDown={onMouseDown as ImgHTMLAttributes<HTMLImageElement>['onMouseDown']}
        onMouseUp={onMouseUp as ImgHTMLAttributes<HTMLImageElement>['onMouseUp']}
        onKeyDown={onKeyDown as ImgHTMLAttributes<HTMLImageElement>['onKeyDown']}
        onKeyUp={onKeyUp as ImgHTMLAttributes<HTMLImageElement>['onKeyUp']}
        onFocus={onFocus as ImgHTMLAttributes<HTMLImageElement>['onFocus']}
        onBlur={onBlur as ImgHTMLAttributes<HTMLImageElement>['onBlur']}
        role={role as ImgHTMLAttributes<HTMLImageElement>['role']}
        tabIndex={tabIndex as ImgHTMLAttributes<HTMLImageElement>['tabIndex']}
        id={id as ImgHTMLAttributes<HTMLImageElement>['id']}
        loading={loading as ImgHTMLAttributes<HTMLImageElement>['loading']}
        decoding={decoding as ImgHTMLAttributes<HTMLImageElement>['decoding']}
        {...passThrough}
      />
    );
  };
  Svg.displayName = name;
  return Svg;
};

const ActionSmallBank = makeSvg('ActionSmallBank', ActionSmallBankUrl);
const ActionSmallCalendar = makeSvg('ActionSmallCalendar', ActionSmallCalendarUrl);
const ActionSmallCloseDefault = makeSvg('ActionSmallCloseDefault', ActionSmallCloseDefaultUrl);
const ActionSmallEdit = makeSvg('ActionSmallEdit', ActionSmallEditUrl);
const ActionSmallEllipsis = makeSvg('ActionSmallEllipsis', ActionSmallEllipsisUrl);
const ActionSmallEnvelopeTertiaryDefault = makeSvg(
  'ActionSmallEnvelopeTertiaryDefault',
  ActionSmallEnvelopeTertiaryDefaultUrl
);
const ActionSmallExportDefault = makeSvg('ActionSmallExportDefault', ActionSmallExportDefaultUrl);
const ActionSmallFilter = makeSvg('ActionSmallFilter', ActionSmallFilterUrl);
const ActionSmallGrip = makeSvg('ActionSmallGrip', ActionSmallGripUrl);
const ActionSmallMenuClose = makeSvg('ActionSmallMenuClose', ActionSmallMenuCloseUrl);
const ActionSmallPhone2TertiaryDefault = makeSvg(
  'ActionSmallPhone2TertiaryDefault',
  ActionSmallPhone2TertiaryDefaultUrl
);
const ActionSmallPlus = makeSvg('ActionSmallPlus', ActionSmallPlusUrl);
const ActionSmallPlusDisabled = makeSvg('ActionSmallPlusDisabled', ActionSmallPlusDisabledUrl);
const ActionSmallScrollToBottom = makeSvg(
  'ActionSmallScrollToBottom',
  ActionSmallScrollToBottomUrl
);
const ActionSmallSignOutTertiary = makeSvg(
  'ActionSmallSignOutTertiary',
  ActionSmallSignOutTertiaryUrl
);
const ActionAdviceIconDefault = makeSvg('ActionAdviceIconDefault', ActionAdviceIconDefaultUrl);
const ActionBudgetIconDefault = makeSvg('ActionBudgetIconDefault', ActionBudgetIconDefaultUrl);
const ActionGoalsIconDefault = makeSvg('ActionGoalsIconDefault', ActionGoalsIconDefaultUrl);
const ActionNetWorthIconDefault = makeSvg(
  'ActionNetWorthIconDefault',
  ActionNetWorthIconDefaultUrl
);
const ActionToolsIconDefault = makeSvg('ActionToolsIconDefault', ActionToolsIconDefaultUrl);
const AppleLogoWhite = makeSvg('AppleLogoWhite', AppleLogoWhiteUrl);
const Arrow = makeSvg('Arrow', ArrowUrl);
const ArtAdvice = makeSvg('ArtAdvice', ArtAdviceUrl);
const ArtApproved = makeSvg('ArtApproved', ArtApprovedUrl);
const ArtBooks = makeSvg('ArtBooks', ArtBooksUrl);
const ArtBrainFog = makeSvg('ArtBrainFog', ArtBrainFogUrl);
const ArtBusiness = makeSvg('ArtBusiness', ArtBusinessUrl);
const ArtCar = makeSvg('ArtCar', ArtCarUrl);
const ArtCar1 = makeSvg('ArtCar1', ArtCar1Url);
const ArtCar2 = makeSvg('ArtCar2', ArtCar2Url);
const ArtCarouselBeachChair = makeSvg('ArtCarouselBeachChair', ArtCarouselBeachChairUrl);
const ArtCarouselBusiness = makeSvg('ArtCarouselBusiness', ArtCarouselBusinessUrl);
const ArtCarouselCar = makeSvg('ArtCarouselCar', ArtCarouselCarUrl);
const ArtCarouselCoinsDown = makeSvg('ArtCarouselCoinsDown', ArtCarouselCoinsDownUrl);
const ArtCarouselCoinsSame = makeSvg('ArtCarouselCoinsSame', ArtCarouselCoinsSameUrl);
const ArtCarouselCoinsUp = makeSvg('ArtCarouselCoinsUp', ArtCarouselCoinsUpUrl);
const ArtCarouselCollege = makeSvg('ArtCarouselCollege', ArtCarouselCollegeUrl);
const ArtCarouselCompass = makeSvg('ArtCarouselCompass', ArtCarouselCompassUrl);
const ArtCarouselCreditCard = makeSvg('ArtCarouselCreditCard', ArtCarouselCreditCardUrl);
const ArtCarouselGifts = makeSvg('ArtCarouselGifts', ArtCarouselGiftsUrl);
const ArtCarouselGifts2 = makeSvg('ArtCarouselGifts2', ArtCarouselGifts2Url);
const ArtCarouselGuitar = makeSvg('ArtCarouselGuitar', ArtCarouselGuitarUrl);
const ArtCarouselHouse = makeSvg('ArtCarouselHouse', ArtCarouselHouseUrl);
const ArtCarouselLoan = makeSvg('ArtCarouselLoan', ArtCarouselLoanUrl);
const ArtCarouselMedical = makeSvg('ArtCarouselMedical', ArtCarouselMedicalUrl);
const ArtCarouselPaintbrush = makeSvg('ArtCarouselPaintbrush', ArtCarouselPaintbrushUrl);
const ArtCarouselPool = makeSvg('ArtCarouselPool', ArtCarouselPoolUrl);
const ArtCarouselSailboat = makeSvg('ArtCarouselSailboat', ArtCarouselSailboatUrl);
const ArtCarouselShopping = makeSvg('ArtCarouselShopping', ArtCarouselShoppingUrl);
const ArtCarouselWedding = makeSvg('ArtCarouselWedding', ArtCarouselWeddingUrl);
const ArtCarouselWheelBarrow = makeSvg('ArtCarouselWheelBarrow', ArtCarouselWheelBarrowUrl);
const ArtCardBeachChair = makeSvg('ArtCardBeachChair', ArtCardBeachChairUrl);
const ArtCardBonds = makeSvg('ArtCardBonds', ArtCardBondsUrl);
const ArtCardCash = makeSvg('ArtCardCash', ArtCardCashUrl);
const ArtCardClock = makeSvg('ArtCardClock', ArtCardClockUrl);
const ArtCardCreditCard = makeSvg('ArtCardCreditCard', ArtCardCreditCardUrl);
const ArtCardDebt = makeSvg('ArtCardDebt', ArtCardDebtUrl);
const ArtCardMoney = makeSvg('ArtCardMoney', ArtCardMoneyUrl);
const ArtCardPiggyBank = makeSvg('ArtCardPiggyBank', ArtCardPiggyBankUrl);
const ArtCardStocks = makeSvg('ArtCardStocks', ArtCardStocksUrl);
const ArtCardTarget = makeSvg('ArtCardTarget', ArtCardTargetUrl);
const ArtCoffee = makeSvg('ArtCoffee', ArtCoffeeUrl);
const ArtCellPhone = makeSvg('ArtCellPhone', ArtCellPhoneUrl);
const ArtChipCalculator = makeSvg('ArtChipCalculator', ArtChipCalculatorUrl);
const ArtChipCollege = makeSvg('ArtChipCollege', ArtChipCollegeUrl);
const ArtChipCreditCard = makeSvg('ArtChipCreditCard', ArtChipCreditCardUrl);
const ArtChipPieChart = makeSvg('ArtChipPieChart', ArtChipPieChartUrl);
const ArtCollegeGradCap = makeSvg('ArtCollegeGradCap', ArtCollegeGradCapUrl);
const ArtComprehensiveInsurance = makeSvg(
  'ArtComprehensiveInsurance',
  ArtComprehensiveInsuranceUrl
);
const ArtCreditScore = makeSvg('ArtCreditScore', ArtCreditScoreUrl);
const ArtConfusedMan = makeSvg('ArtConfusedMan', ArtConfusedManUrl);
const ArtCreditCard = makeSvg('ArtCreditCard', ArtCreditCardUrl);
const ArtCreditCard2 = makeSvg('ArtCreditCard2', ArtCreditCard2Url);
const ArtCreditCard3 = makeSvg('ArtCreditCard3', ArtCreditCard3Url);
const ArtDashboardChecklist = makeSvg('ArtDashboardChecklist', ArtDashboardChecklistUrl);
const ArtDashboardLightbulb = makeSvg('ArtDashboardLightbulb', ArtDashboardLightbulbUrl);
const ArtDashboardMagnifyingGlass = makeSvg(
  'ArtDashboardMagnifyingGlass',
  ArtDashboardMagnifyingGlassUrl
);
const ArtDebtSmall = makeSvg('ArtDebtSmall', ArtDebtSmallUrl);
const ArtDebt = makeSvg('ArtDebt', ArtDebtUrl);
const ArtDonation = makeSvg('ArtDonation', ArtDonationUrl);
const ArtGivingCollege = makeSvg('ArtGivingCollege', ArtGivingCollegeUrl);
const ArtGivingHeart2 = makeSvg('ArtGivingHeart2', ArtGivingHeart2Url);
const ArtHandClap = makeSvg('ArtHandClap', ArtHandClapUrl);
const ArtHandshake = makeSvg('ArtHandshake', ArtHandshakeUrl);
const ArtHealthInsurance = makeSvg('ArtHealthInsurance', ArtHealthInsuranceUrl);
const ArtHealthInsurance2 = makeSvg('ArtHealthInsurance2', ArtHealthInsurance2Url);
const ArtHeart = makeSvg('ArtHeart', ArtHeartUrl);
const ArtHouse = makeSvg('ArtHouse', ArtHouseUrl);
const ArtHouseKeys = makeSvg('ArtHouseKeys', ArtHouseKeysUrl);
const ArtHouseLarge = makeSvg('ArtHouseLarge', ArtHouseLargeUrl);
const ArtInvestmentData = makeSvg('ArtInvestmentData', ArtInvestmentDataUrl);
const ArtLaptopLarge = makeSvg('ArtLaptopLarge', ArtLaptopLargeUrl);
const ArtLaptop = makeSvg('ArtLaptop', ArtLaptopUrl);
const ArtLifestyle = makeSvg('ArtLifestyle', ArtLifestyleUrl);
const ArtLightbulbLarge = makeSvg('ArtLightbulbLarge', ArtLightbulbLargeUrl);
const ArtLightbulbMedium = makeSvg('ArtLightbulbMedium', ArtLightbulbMediumUrl);
const ArtLightbulbSmall = makeSvg('ArtLightbulbSmall', ArtLightbulbSmallUrl);
const ArtMagnifyingGlass = makeSvg('ArtMagnifyingGlass', ArtMagnifyingGlassUrl);
const ArtMedicalSupplies = makeSvg('ArtMedicalSupplies', ArtMedicalSuppliesUrl);
const ArtMeditation = makeSvg('ArtMeditation', ArtMeditationUrl);
const ArtMoneyLarge = makeSvg('ArtMoneyLarge', ArtMoneyLargeUrl);
const ArtMoneyPlant = makeSvg('ArtMoneyPlant', ArtMoneyPlantUrl);
const ArtMoneySmall = makeSvg('ArtMoneySmall', ArtMoneySmallUrl);
const ArtOrganization = makeSvg('ArtOrganization', ArtOrganizationUrl);
const ArtPieChart = makeSvg('ArtPieChart', ArtPieChartUrl);
const ArtPieChartLarge = makeSvg('ArtPieChartLarge', ArtPieChartLargeUrl);
const ArtPiggyBank2 = makeSvg('ArtPiggyBank2', ArtPiggyBank2Url);
const ArtPiggyBank3 = makeSvg('ArtPiggyBank3', ArtPiggyBank3Url);
const ArtPlant = makeSvg('ArtPlant', ArtPlantUrl);
const ArtPresents = makeSvg('ArtPresents', ArtPresentsUrl);
const ArtQuestion = makeSvg('ArtQuestion', ArtQuestionUrl);
const ArtPiggyBank = makeSvg('ArtPiggyBank', ArtPiggyBankUrl);
const ArtRetirement = makeSvg('ArtRetirement', ArtRetirementUrl);
const ArtRetirementLarge = makeSvg('ArtRetirementLarge', ArtRetirementLargeUrl);
const ArtRetirementSmall = makeSvg('ArtRetirementSmall', ArtRetirementSmallUrl);
const LinkPaperClip = makeSvg('LinkPaperClip', LinkPaperClipUrl);
const LogoHeyNicIconOnly = makeSvg('LogoHeyNicIconOnly', LogoHeyNicIconOnlyUrl);
const LogoTithelyIconOnly = makeSvg('LogoTithelyIconOnly', LogoTithelyIconOnlyUrl);
const LogoTithely = makeSvg('LogoTithely', LogoTithelyUrl);
const ArtRibbon = makeSvg('ArtRibbon', ArtRibbonUrl);
const ArtStudyMaterials = makeSvg('ArtStudyMaterials', ArtStudyMaterialsUrl);
const ArtTarget = makeSvg('ArtTarget', ArtTargetUrl);
const ArtTargetSmall = makeSvg('ArtTargetSmall', ArtTargetSmallUrl);
const ArtThumbsUp = makeSvg('ArtThumbsUp', ArtThumbsUpUrl);
const ArtTrophySmall2 = makeSvg('ArtTrophySmall2', ArtTrophySmall2Url);
const ArtUmbrella2 = makeSvg('ArtUmbrella2', ArtUmbrella2Url);
const ArtUmbrella = makeSvg('ArtUmbrella', ArtUmbrellaUrl);
const ArtUni3N = makeSvg('ArtUni3N', ArtUni3NUrl);
const BeachChair = makeSvg('BeachChair', BeachChairUrl);
const BulletBook = makeSvg('BulletBook', BulletBookUrl);
const BulletCalculator = makeSvg('BulletCalculator', BulletCalculatorUrl);
const BulletChecklist = makeSvg('BulletChecklist', BulletChecklistUrl);
const BulletCoach = makeSvg('BulletCoach', BulletCoachUrl);
const BulletInvestmentGC = makeSvg('BulletInvestmentGC', BulletInvestmentGCUrl);
const BulletInvestment = makeSvg('BulletInvestment', BulletInvestmentUrl);
const BulletLessons = makeSvg('BulletLessons', BulletLessonsUrl);
const BulletLoans = makeSvg('BulletLoans', BulletLoansUrl);
const BulletPiggyBank = makeSvg('BulletPiggyBank', BulletPiggyBankUrl);
const BulletPiggyBankGc = makeSvg('BulletPiggyBankGc', BulletPiggyBankGcUrl);
const BulletQa = makeSvg('BulletQa', BulletQaUrl);
const BulletStatistics = makeSvg('BulletStatistics', BulletStatisticsUrl);
const Car = makeSvg('Car', CarUrl);
const CardGradient = makeSvg('CardGradient', CardGradientUrl);
const Cash = makeSvg('Cash', CashUrl);
const CollegeGradCap = makeSvg('CollegeGradCap', CollegeGradCapUrl);
const Confetti = makeSvg('Confetti', ConfettiUrl);
const Debt = makeSvg('Debt', DebtUrl);
const DisplayExtraSmallCustomCheckmark = makeSvg(
  'DisplayExtraSmallCustomCheckmark',
  DisplayExtraSmallCustomCheckmarkUrl
);
const DisplayExtraSmallCustomX = makeSvg('DisplayExtraSmallCustomX', DisplayExtraSmallCustomXUrl);
const DisplayHamburgerMenuChatPrimary = makeSvg(
  'DisplayHamburgerMenuChatPrimary',
  DisplayHamburgerMenuChatPrimaryUrl
);
const DisplayHamburgerMenuChatSecondary = makeSvg(
  'DisplayHamburgerMenuChatSecondary',
  DisplayHamburgerMenuChatSecondaryUrl
);
const DisplayHamburgerMenuPremium = makeSvg(
  'DisplayHamburgerMenuPremium',
  DisplayHamburgerMenuPremiumUrl
);
const DisplayHamburgerMenuSignOut = makeSvg(
  'DisplayHamburgerMenuSignOut',
  DisplayHamburgerMenuSignOutUrl
);
const DisplayHamburgerMenuSignOutPrimary = makeSvg(
  'DisplayHamburgerMenuSignOutPrimary',
  DisplayHamburgerMenuSignOutPrimaryUrl
);
const DisplayHamburgerMenuHeadset = makeSvg(
  'DisplayHamburgerMenuHeadset',
  DisplayHamburgerMenuHeadsetUrl
);
const DisplayHamburgerMenuHeadsetPrimary = makeSvg(
  'DisplayHamburgerMenuHeadsetPrimary',
  DisplayHamburgerMenuHeadsetPrimaryUrl
);
const DisplayLargeCustomCheckmark = makeSvg(
  'DisplayLargeCustomCheckmark',
  DisplayLargeCustomCheckmarkUrl
);
const DisplayLargeCustomClock = makeSvg('DisplayLargeCustomClock', DisplayLargeCustomClockUrl);
const DisplayLargeCustomCollision3 = makeSvg(
  'DisplayLargeCustomCollision3',
  DisplayLargeCustomCollision3Url
);
const DisplayLargeCustomHomeOffer = makeSvg(
  'DisplayLargeCustomHomeOffer',
  DisplayLargeCustomHomeOfferUrl
);
const DisplayLargeCustomHomeSale = makeSvg(
  'DisplayLargeCustomHomeSale',
  DisplayLargeCustomHomeSaleUrl
);
const DisplayLargeCustomHouse = makeSvg('DisplayLargeCustomHouse', DisplayLargeCustomHouseUrl);
const DisplayLargeCustomLegalDocs = makeSvg(
  'DisplayLargeCustomLegalDocs',
  DisplayLargeCustomLegalDocsUrl
);
const DisplayLargeCustomMedical = makeSvg(
  'DisplayLargeCustomMedical',
  DisplayLargeCustomMedicalUrl
);
const DisplayLargeCustomMoneyBag = makeSvg(
  'DisplayLargeCustomMoneyBag',
  DisplayLargeCustomMoneyBagUrl
);
const DisplayLargeCustomMoneyExchange = makeSvg(
  'DisplayLargeCustomMoneyExchange',
  DisplayLargeCustomMoneyExchangeUrl
);
const DisplayLargeCustomPaintRoller = makeSvg(
  'DisplayLargeCustomPaintRoller',
  DisplayLargeCustomPaintRollerUrl
);
const DisplayLargeCustomRetirement = makeSvg(
  'DisplayLargeCustomRetirement',
  DisplayLargeCustomRetirementUrl
);
const DisplayLargeCustomSaleProceeds = makeSvg(
  'DisplayLargeCustomSaleProceeds',
  DisplayLargeCustomSaleProceedsUrl
);
const DisplayLargeCustomScale = makeSvg('DisplayLargeCustomScale', DisplayLargeCustomScaleUrl);
const DisplayLargeCustomTax = makeSvg('DisplayLargeCustomTax', DisplayLargeCustomTaxUrl);
const DisplayLargeCustomWarning = makeSvg(
  'DisplayLargeCustomWarning',
  DisplayLargeCustomWarningUrl
);
const DisplayLargeCustomWarningErrorBase = makeSvg(
  'DisplayLargeCustomWarningErrorBase',
  DisplayLargeCustomWarningErrorBaseUrl
);
const DisplaySmallCustomXFilled = makeSvg(
  'DisplaySmallCustomXFilled',
  DisplaySmallCustomXFilledUrl
);
const DisplayMediumCustomBirthdayCake = makeSvg(
  'DisplayMediumCustomBirthdayCake',
  DisplayMediumCustomBirthdayCakeUrl
);
const DisplayMediumCustomBriefcasePrimary = makeSvg(
  'DisplayMediumCustomBriefcasePrimary',
  DisplayMediumCustomBriefcasePrimaryUrl
);
const DisplayMediumCustomBriefcase = makeSvg(
  'DisplayMediumCustomBriefcase',
  DisplayMediumCustomBriefcaseUrl
);
const DisplayMediumCustomBus = makeSvg('DisplayMediumCustomBus', DisplayMediumCustomBusUrl);
const DisplayMediumCustomCancel = makeSvg(
  'DisplayMediumCustomCancel',
  DisplayMediumCustomCancelUrl
);
const DisplayMediumCustomCar = makeSvg('DisplayMediumCustomCar', DisplayMediumCustomCarUrl);
const DisplayMediumCustomCarSecondary = makeSvg(
  'DisplayMediumCustomCarSecondary',
  DisplayMediumCustomCarSecondaryUrl
);
const DisplayMediumCustomCaution = makeSvg(
  'DisplayMediumCustomCaution',
  DisplayMediumCustomCautionUrl
);
const DisplayMediumCustomCellPhone = makeSvg(
  'DisplayMediumCustomCellPhone',
  DisplayMediumCustomCellPhoneUrl
);
const DisplayMediumCustomCoffee = makeSvg(
  'DisplayMediumCustomCoffee',
  DisplayMediumCustomCoffeeUrl
);
const DisplayMediumCustomCreditCard = makeSvg(
  'DisplayMediumCustomCreditCard',
  DisplayMediumCustomCreditCardUrl
);
const DisplayMediumCustomGender = makeSvg(
  'DisplayMediumCustomGender',
  DisplayMediumCustomGenderUrl
);
const DisplayMediumCustomGlass = makeSvg('DisplayMediumCustomGlass', DisplayMediumCustomGlassUrl);
const DisplayMediumCustomHandshake = makeSvg(
  'DisplayMediumCustomHandshake',
  DisplayMediumCustomHandshakeUrl
);
const DisplayMediumCustomHeart = makeSvg('DisplayMediumCustomHeart', DisplayMediumCustomHeartUrl);
const DisplayMediumCustomLightbulb = makeSvg(
  'DisplayMediumCustomLightbulb',
  DisplayMediumCustomLightbulbUrl
);
const DisplayMediumCustomLocation = makeSvg(
  'DisplayMediumCustomLocation',
  DisplayMediumCustomLocationUrl
);
const DisplayMediumCustomPlane = makeSvg('DisplayMediumCustomPlane', DisplayMediumCustomPlaneUrl);
const DisplayMediumCustomReceipt = makeSvg(
  'DisplayMediumCustomReceipt',
  DisplayMediumCustomReceiptUrl
);
const DisplayMediumCustomRibbon = makeSvg(
  'DisplayMediumCustomRibbon',
  DisplayMediumCustomRibbonUrl
);
const DisplayMediumCustomShoppingCart = makeSvg(
  'DisplayMediumCustomShoppingCart',
  DisplayMediumCustomShoppingCartUrl
);
const DisplayMediumCustomSpeedometer = makeSvg(
  'DisplayMediumCustomSpeedometer',
  DisplayMediumCustomSpeedometerUrl
);
const DisplayMediumCustomTV = makeSvg('DisplayMediumCustomTV', DisplayMediumCustomTVUrl);
const DisplayMediumCustomUmbrella = makeSvg(
  'DisplayMediumCustomUmbrella',
  DisplayMediumCustomUmbrellaUrl
);
const DisplayMediumPrimaryAnotherBehalf = makeSvg(
  'DisplayMediumPrimaryAnotherBehalf',
  DisplayMediumPrimaryAnotherBehalfUrl
);
const DisplayMediumPrimaryBudget = makeSvg(
  'DisplayMediumPrimaryBudget',
  DisplayMediumPrimaryBudgetUrl
);
const DisplayMediumPrimaryCar = makeSvg('DisplayMediumPrimaryCar', DisplayMediumPrimaryCarUrl);
const DisplayMediumPrimaryCoins = makeSvg(
  'DisplayMediumPrimaryCoins',
  DisplayMediumPrimaryCoinsUrl
);
const DisplayMediumPrimaryCoinStack = makeSvg(
  'DisplayMediumPrimaryCoinStack',
  DisplayMediumPrimaryCoinStackUrl
);
const DisplayMediumPrimaryCollege = makeSvg(
  'DisplayMediumPrimaryCollege',
  DisplayMediumPrimaryCollegeUrl
);
const DisplayMediumPrimaryCreditCard = makeSvg(
  'DisplayMediumPrimaryCreditCard',
  DisplayMediumPrimaryCreditCardUrl
);
const DisplayMediumPrimaryDebt = makeSvg('DisplayMediumPrimaryDebt', DisplayMediumPrimaryDebtUrl);
const DisplayMediumPrimaryGifts = makeSvg(
  'DisplayMediumPrimaryGifts',
  DisplayMediumPrimaryGiftsUrl
);
const DisplayMediumPrimaryGoals = makeSvg(
  'DisplayMediumPrimaryGoals',
  DisplayMediumPrimaryGoalsUrl
);
const DisplayMediumPrimaryHouse = makeSvg(
  'DisplayMediumPrimaryHouse',
  DisplayMediumPrimaryHouseUrl
);
const DisplayMediumPrimaryInvestment = makeSvg(
  'DisplayMediumPrimaryInvestment',
  DisplayMediumPrimaryInvestmentUrl
);
const DisplayMediumPrimaryLegacy = makeSvg(
  'DisplayMediumPrimaryLegacy',
  DisplayMediumPrimaryLegacyUrl
);
const DisplayMediumPrimaryLoans = makeSvg(
  'DisplayMediumPrimaryLoans',
  DisplayMediumPrimaryLoansUrl
);
const DisplayMediumPrimaryMedical = makeSvg(
  'DisplayMediumPrimaryMedical',
  DisplayMediumPrimaryMedicalUrl
);
const DisplayMediumPrimaryPiggyBank = makeSvg(
  'DisplayMediumPrimaryPiggyBank',
  DisplayMediumPrimaryPiggyBankUrl
);
const DisplayMediumPrimaryPlane = makeSvg(
  'DisplayMediumPrimaryPlane',
  DisplayMediumPrimaryPlaneUrl
);
const DisplayMediumPrimaryRetirement = makeSvg(
  'DisplayMediumPrimaryRetirement',
  DisplayMediumPrimaryRetirementUrl
);
const DisplayMediumPrimaryTax = makeSvg('DisplayMediumPrimaryTax', DisplayMediumPrimaryTaxUrl);
const DisplayMediumPrimaryTime = makeSvg('DisplayMediumPrimaryTime', DisplayMediumPrimaryTimeUrl);
const DisplayMediumPrimaryUmbrella = makeSvg(
  'DisplayMediumPrimaryUmbrella',
  DisplayMediumPrimaryUmbrellaUrl
);
const DisplaySmallCreditCardGrayFilled = makeSvg(
  'DisplaySmallCreditCardGrayFilled',
  DisplaySmallCreditCardGrayFilledUrl
);
const DisplaySmallCreditCardPrimaryBaseFilled = makeSvg(
  'DisplaySmallCreditCardPrimaryBaseFilled',
  DisplaySmallCreditCardPrimaryBaseFilledUrl
);
const DisplaySmallCreditCardPrimaryLightFilled = makeSvg(
  'DisplaySmallCreditCardPrimaryLightFilled',
  DisplaySmallCreditCardPrimaryLightFilledUrl
);
const DisplaySmallCreditCardPrimaryLightOutlined = makeSvg(
  'DisplaySmallCreditCardPrimaryLightOutlined',
  DisplaySmallCreditCardPrimaryLightOutlinedUrl
);
const DisplaySmallCustomAdvice = makeSvg('DisplaySmallCustomAdvice', DisplaySmallCustomAdviceUrl);
const DisplaySmallCustomAlerts = makeSvg('DisplaySmallCustomAlerts', DisplaySmallCustomAlertsUrl);
const DisplaySmallCustomBirthdayCake = makeSvg(
  'DisplaySmallCustomBirthdayCake',
  DisplaySmallCustomBirthdayCakeUrl
);
const DisplaySmallCustomBook = makeSvg('DisplaySmallCustomBook', DisplaySmallCustomBookUrl);
const DisplaySmallCustomBudget = makeSvg('DisplaySmallCustomBudget', DisplaySmallCustomBudgetUrl);
const DisplaySmallCustomBudget2 = makeSvg(
  'DisplaySmallCustomBudget2',
  DisplaySmallCustomBudget2Url
);
const DisplaySmallCustomBank = makeSvg('DisplaySmallCustomBank', DisplaySmallCustomBankUrl);
const DisplaySmallCustomBriefcase = makeSvg(
  'DisplaySmallCustomBriefcase',
  DisplaySmallCustomBriefcaseUrl
);
const DisplaySmallCustomCalculator = makeSvg(
  'DisplaySmallCustomCalculator',
  DisplaySmallCustomCalculatorUrl
);
const DisplaySmallCustomCalendar = makeSvg(
  'DisplaySmallCustomCalendar',
  DisplaySmallCustomCalendarUrl
);
const DisplaySmallCustomCar = makeSvg('DisplaySmallCustomCar', DisplaySmallCustomCarUrl);
const DisplaySmallCustomChat = makeSvg('DisplaySmallCustomChat', DisplaySmallCustomChatUrl);
const DisplaySmallCustomChatActive = makeSvg(
  'DisplaySmallCustomChatActive',
  DisplaySmallCustomChatActiveUrl
);
const DisplaySmallCustomChecklist = makeSvg(
  'DisplaySmallCustomChecklist',
  DisplaySmallCustomChecklistUrl
);
const DisplaySmallCustomCheckmarkFilled = makeSvg(
  'DisplaySmallCustomCheckmarkFilled',
  DisplaySmallCustomCheckmarkFilledUrl
);
const DisplaySmallCustomCheckmark = makeSvg(
  'DisplaySmallCustomCheckmark',
  DisplaySmallCustomCheckmarkUrl
);
const DisplaySmallCustomClock = makeSvg('DisplaySmallCustomClock', DisplaySmallCustomClockUrl);
const DisplaySmallCustomCoins = makeSvg('DisplaySmallCustomCoins', DisplaySmallCustomCoinsUrl);
const DisplaySmallCustomCollision = makeSvg(
  'DisplaySmallCustomCollision',
  DisplaySmallCustomCollisionUrl
);
const DisplaySmallCustomCreditCard = makeSvg(
  'DisplaySmallCustomCreditCard',
  DisplaySmallCustomCreditCardUrl
);
const DisplaySmallCustomCreditCardPrimary = makeSvg(
  'DisplaySmallCustomCreditCardPrimary',
  DisplaySmallCustomCreditCardPrimaryUrl
);
const DisplaySmallCustomCreditCard2 = makeSvg(
  'DisplaySmallCustomCreditCard2',
  DisplaySmallCustomCreditCard2Url
);
const DisplaySmallCustomCreditCard3 = makeSvg(
  'DisplaySmallCustomCreditCard3',
  DisplaySmallCustomCreditCard3Url
);
const DisplaySmallCustomDeposit = makeSvg(
  'DisplaySmallCustomDeposit',
  DisplaySmallCustomDepositUrl
);
const DisplaySmallCustomDebt = makeSvg('DisplaySmallCustomDebt', DisplaySmallCustomDebtUrl);
const DisplaySmallCustomDebt2 = makeSvg('DisplaySmallCustomDebt2', DisplaySmallCustomDebt2Url);
const DisplaySmallCustomDocUpload = makeSvg(
  'DisplaySmallCustomDocUpload',
  DisplaySmallCustomDocUploadUrl
);
const DisplaySmallCustomEnvelope = makeSvg(
  'DisplaySmallCustomEnvelope',
  DisplaySmallCustomEnvelopeUrl
);
const DisplaySmallCustomFax = makeSvg('DisplaySmallCustomFax', DisplaySmallCustomFaxUrl);
const DisplaySmallCustomFood = makeSvg('DisplaySmallCustomFood', DisplaySmallCustomFoodUrl);
const DisplaySmallCustomFoodYellow = makeSvg(
  'DisplaySmallCustomFoodYellow',
  DisplaySmallCustomFoodYellowUrl
);
const DisplaySmallCustomFunnel = makeSvg('DisplaySmallCustomFunnel', DisplaySmallCustomFunnelUrl);
const DisplaySmallCustomGifts = makeSvg('DisplaySmallCustomGifts', DisplaySmallCustomGiftsUrl);
const DisplaySmallCustomGiftsPrimary = makeSvg(
  'DisplaySmallCustomGiftsPrimary',
  DisplaySmallCustomGiftsPrimaryUrl
);
const DisplaySmallCustomGoals = makeSvg('DisplaySmallCustomGoals', DisplaySmallCustomGoalsUrl);
const DisplaySmallCustomGoals2 = makeSvg('DisplaySmallCustomGoals2', DisplaySmallCustomGoals2Url);
const DisplaySmallCustomHandshake = makeSvg(
  'DisplaySmallCustomHandshake',
  DisplaySmallCustomHandshakeUrl
);
const DisplaySmallCustomHealthInsurance = makeSvg(
  'DisplaySmallCustomHealthInsurance',
  DisplaySmallCustomHealthInsuranceUrl
);
const DisplaySmallCustomHeyNic = makeSvg('DisplaySmallCustomHeyNic', DisplaySmallCustomHeyNicUrl);
const DisplaySmallCustomHomeSale = makeSvg(
  'DisplaySmallCustomHomeSale',
  DisplaySmallCustomHomeSaleUrl
);
const DisplaySmallCustomHouse = makeSvg('DisplaySmallCustomHouse', DisplaySmallCustomHouseUrl);
const DisplaySmallCustomHouseAfford = makeSvg(
  'DisplaySmallCustomHouseAfford',
  DisplaySmallCustomHouseAffordUrl
);
const DisplaySmallCustomHouseKeys = makeSvg(
  'DisplaySmallCustomHouseKeys',
  DisplaySmallCustomHouseKeysUrl
);
const DisplaySmallCustomInfo = makeSvg('DisplaySmallCustomInfo', DisplaySmallCustomInfoUrl);
const DisplaySmallCustomInstitution = makeSvg(
  'DisplaySmallCustomInstitution',
  DisplaySmallCustomInstitutionUrl
);
const DisplaySmallCustomInvestment = makeSvg(
  'DisplaySmallCustomInvestment',
  DisplaySmallCustomInvestmentUrl
);
const DisplaySmallCustomInvestment2 = makeSvg(
  'DisplaySmallCustomInvestment2',
  DisplaySmallCustomInvestment2Url
);
const DisplaySmallCustomItemization = makeSvg(
  'DisplaySmallCustomItemization',
  DisplaySmallCustomItemizationUrl
);
const DisplaySmallCustomLegacy = makeSvg('DisplaySmallCustomLegacy', DisplaySmallCustomLegacyUrl);
const DisplaySmallCustomLightBulb = makeSvg(
  'DisplaySmallCustomLightBulb',
  DisplaySmallCustomLightBulbUrl
);
const DisplaySmallCustomLinkAccount = makeSvg(
  'DisplaySmallCustomLinkAccount',
  DisplaySmallCustomLinkAccountUrl
);
const DisplaySmallCustomLoans = makeSvg('DisplaySmallCustomLoans', DisplaySmallCustomLoansUrl);
const DisplaySmallCustomLoansSecondary = makeSvg(
  'DisplaySmallCustomLoansSecondary',
  DisplaySmallCustomLoansSecondaryUrl
);
const DisplaySmallCustomLock = makeSvg('DisplaySmallCustomLock', DisplaySmallCustomLockUrl);
const DisplaySmallCustomLockGray = makeSvg(
  'DisplaySmallCustomLockGray',
  DisplaySmallCustomLockGrayUrl
);
const DisplaySmallCustomMarketplace = makeSvg(
  'DisplaySmallCustomMarketplace',
  DisplaySmallCustomMarketplaceUrl
);
const DisplaySmallCustomMedical = makeSvg(
  'DisplaySmallCustomMedical',
  DisplaySmallCustomMedicalUrl
);
const DisplaySmallCustomMedicalUmbrella = makeSvg(
  'DisplaySmallCustomMedicalUmbrella',
  DisplaySmallCustomMedicalUmbrellaUrl
);
const DisplaySmallCustomMembers = makeSvg(
  'DisplaySmallCustomMembers',
  DisplaySmallCustomMembersUrl
);
const DisplaySmallCustomOnTarget = makeSvg(
  'DisplaySmallCustomOnTarget',
  DisplaySmallCustomOnTargetUrl
);
const DisplaySmallCustomOrganization = makeSvg(
  'DisplaySmallCustomOrganization',
  DisplaySmallCustomOrganizationUrl
);
const DisplaySmallCustomPayOff = makeSvg('DisplaySmallCustomPayOff', DisplaySmallCustomPayOffUrl);
const DisplaySmallCustomPercent = makeSvg(
  'DisplaySmallCustomPercent',
  DisplaySmallCustomPercentUrl
);
const DisplaySmallCustomPhone2 = makeSvg('DisplaySmallCustomPhone2', DisplaySmallCustomPhone2Url);
const DisplaySmallCustomPiggyBank = makeSvg(
  'DisplaySmallCustomPiggyBank',
  DisplaySmallCustomPiggyBankUrl
);
const DisplaySmallCustomPlan = makeSvg('DisplaySmallCustomPlan', DisplaySmallCustomPlanUrl);
const DisplaySmallCustomProfileActive = makeSvg(
  'DisplaySmallCustomProfileActive',
  DisplaySmallCustomProfileActiveUrl
);
const DisplaySmallCustomProfileDefault = makeSvg(
  'DisplaySmallCustomProfileDefault',
  DisplaySmallCustomProfileDefaultUrl
);
const DisplaySmallCustomProgressComplete = makeSvg(
  'DisplaySmallCustomProgressComplete',
  DisplaySmallCustomProgressCompleteUrl
);
const DisplaySmallCustomPromotions = makeSvg(
  'DisplaySmallCustomPromotions',
  DisplaySmallCustomPromotionsUrl
);
const DisplaySmallCustomRentOrBuy = makeSvg(
  'DisplaySmallCustomRentOrBuy',
  DisplaySmallCustomRentOrBuyUrl
);
const DisplaySmallCustomRetirement = makeSvg(
  'DisplaySmallCustomRetirement',
  DisplaySmallCustomRetirementUrl
);
const DisplaySmallCustomScale = makeSvg('DisplaySmallCustomScale', DisplaySmallCustomScaleUrl);
const DisplaySmallCustomSearch = makeSvg('DisplaySmallCustomSearch', DisplaySmallCustomSearchUrl);
const DisplaySmallCustomShield = makeSvg('DisplaySmallCustomShield', DisplaySmallCustomShieldUrl);
const DisplaySmallCustomShoppingCart = makeSvg(
  'DisplaySmallCustomShoppingCart',
  DisplaySmallCustomShoppingCartUrl
);
const DisplaySmallCustomStatistics = makeSvg(
  'DisplaySmallCustomStatistics',
  DisplaySmallCustomStatisticsUrl
);
const DisplaySmallCustomTax = makeSvg('DisplaySmallCustomTax', DisplaySmallCustomTaxUrl);
const DisplaySmallCustomThumbsDown = makeSvg(
  'DisplaySmallCustomThumbsDown',
  DisplaySmallCustomThumbsDownUrl
);
const DisplaySmallCustomThumbsUp = makeSvg(
  'DisplaySmallCustomThumbsUp',
  DisplaySmallCustomThumbsUpUrl
);
const DisplaySmallCustomTools = makeSvg('DisplaySmallCustomTools', DisplaySmallCustomToolsUrl);
const DisplaySmallCustomUmbrella = makeSvg(
  'DisplaySmallCustomUmbrella',
  DisplaySmallCustomUmbrellaUrl
);
const DisplaySmallCustomVacation = makeSvg(
  'DisplaySmallCustomVacation',
  DisplaySmallCustomVacationUrl
);
const DisplaySmallCustomVideoCamera = makeSvg(
  'DisplaySmallCustomVideoCamera',
  DisplaySmallCustomVideoCameraUrl
);
const DisplaySmallCustomWallet = makeSvg('DisplaySmallCustomWallet', DisplaySmallCustomWalletUrl);
const DisplaySmallCustomWalletPrimary = makeSvg(
  'DisplaySmallCustomWalletPrimary',
  DisplaySmallCustomWalletPrimaryUrl
);
const DisplaySmallCustomWarning = makeSvg(
  'DisplaySmallCustomWarning',
  DisplaySmallCustomWarningUrl
);
const DisplaySmallPrimaryLightBook = makeSvg(
  'DisplaySmallPrimaryLightBook',
  DisplaySmallPrimaryLightBookUrl
);
const DisplaySmallPrimaryLightLock = makeSvg(
  'DisplaySmallPrimaryLightLock',
  DisplaySmallPrimaryLightLockUrl
);
const DisplaySmallSecondaryBasePiggyBank = makeSvg(
  'DisplaySmallSecondaryBasePiggyBank',
  DisplaySmallSecondaryBasePiggyBankUrl
);
const DisplaySmallWhiteBank = makeSvg('DisplaySmallWhiteBank', DisplaySmallWhiteBankUrl);
const DisplaySmallWhiteBook = makeSvg('DisplaySmallWhiteBook', DisplaySmallWhiteBookUrl);
const DisplaySmallWhiteBudget = makeSvg('DisplaySmallWhiteBudget', DisplaySmallWhiteBudgetUrl);
const DisplaySmallWhiteCar = makeSvg('DisplaySmallWhiteCar', DisplaySmallWhiteCarUrl);
const DisplaySmallWhiteCoins = makeSvg('DisplaySmallWhiteCoins', DisplaySmallWhiteCoinsUrl);
const DisplaySmallWhiteCollege = makeSvg('DisplaySmallWhiteCollege', DisplaySmallWhiteCollegeUrl);
const DisplaySmallWhiteDeposit = makeSvg('DisplaySmallWhiteDeposit', DisplaySmallWhiteDepositUrl);
const DisplaySmallWhiteFood = makeSvg('DisplaySmallWhiteFood', DisplaySmallWhiteFoodUrl);
const DisplaySmallWhiteHandshake = makeSvg(
  'DisplaySmallWhiteHandshake',
  DisplaySmallWhiteHandshakeUrl
);
const DisplaySmallWhiteHealthInsurance = makeSvg(
  'DisplaySmallWhiteHealthInsurance',
  DisplaySmallWhiteHealthInsuranceUrl
);
const DisplaySmallWhiteHouse = makeSvg('DisplaySmallWhiteHouse', DisplaySmallWhiteHouseUrl);
const DisplaySmallWhiteItemization = makeSvg(
  'DisplaySmallWhiteItemization',
  DisplaySmallWhiteItemizationUrl
);
const DisplaySmallWhiteLegacy = makeSvg('DisplaySmallWhiteLegacy', DisplaySmallWhiteLegacyUrl);
const DisplaySmallWhiteLightBulb = makeSvg(
  'DisplaySmallWhiteLightBulb',
  DisplaySmallWhiteLightBulbUrl
);
const DisplaySmallWhiteLoans = makeSvg('DisplaySmallWhiteLoans', DisplaySmallWhiteLoansUrl);
const DisplaySmallWhiteMedical = makeSvg('DisplaySmallWhiteMedical', DisplaySmallWhiteMedicalUrl);
const DisplaySmallWhiteMembers = makeSvg('DisplaySmallWhiteMembers', DisplaySmallWhiteMembersUrl);
const DisplaySmallWhitePlan = makeSvg('DisplaySmallWhitePlan', DisplaySmallWhitePlanUrl);
const DisplaySmallWhiteRetirement = makeSvg(
  'DisplaySmallWhiteRetirement',
  DisplaySmallWhiteRetirementUrl
);
const DisplaySmallWhiteShoppingCart = makeSvg(
  'DisplaySmallWhiteShoppingCart',
  DisplaySmallWhiteShoppingCartUrl
);
const DisplaySmallWhiteVacation = makeSvg(
  'DisplaySmallWhiteVacation',
  DisplaySmallWhiteVacationUrl
);
const DisplaySmallWhiteVideoCamera = makeSvg(
  'DisplaySmallWhiteVideoCamera',
  DisplaySmallWhiteVideoCameraUrl
);
const DisplaySmallWhiteWallet = makeSvg('DisplaySmallWhiteWallet', DisplaySmallWhiteWalletUrl);
const DisplaySmallWhiteWithdraw = makeSvg(
  'DisplaySmallWhiteWithdraw',
  DisplaySmallWhiteWithdrawUrl
);
const DownArrowSecondary = makeSvg('DownArrowSecondary', DownArrowSecondaryUrl);
const GivingHeart = makeSvg('GivingHeart', GivingHeartUrl);
const House = makeSvg('House', HouseUrl);
const DisplaySmallCustomWithdraw = makeSvg(
  'DisplaySmallCustomWithdraw',
  DisplaySmallCustomWithdrawUrl
);
const Icon3NUCoach = makeSvg('Icon3NUCoach', Icon3NUCoachUrl);
const Icon3NULessons = makeSvg('Icon3NULessons', Icon3NULessonsUrl);
const Icon3NUQa = makeSvg('Icon3NUQa', Icon3NUQaUrl);
const IconAdd = makeSvg('IconAdd', IconAddUrl);
const IconAdminsActive = makeSvg('IconAdminsActive', IconAdminsActiveUrl);
const IconAdminsDefault = makeSvg('IconAdminsDefault', IconAdminsDefaultUrl);
const IconArrowDown = makeSvg('IconArrowDown', IconArrowDownUrl);
const IconArrowLeft = makeSvg('IconArrowLeft', IconArrowLeftUrl);
const IconArrowLeftDisabled = makeSvg('IconArrowLeftDisabled', IconArrowLeftDisabledUrl);
const IconArrowRight = makeSvg('IconArrowRight', IconArrowRightUrl);
const IconArrowRightDisabled = makeSvg('IconArrowRightDisabled', IconArrowRightDisabledUrl);
const IconArrowRightWhite = makeSvg('IconArrowRightWhite', IconArrowRightWhiteUrl);
const IconBook = makeSvg('IconBook', IconBookUrl);
const IconCalculator = makeSvg('IconCalculator', IconCalculatorUrl);
const IconChat = makeSvg('IconChat', IconChatUrl);
const IconChecklist = makeSvg('IconChecklist', IconChecklistUrl);
const IconCheckmark = makeSvg('IconCheckmark', IconCheckmarkUrl);
const IconCheckmarkGreen = makeSvg('IconCheckmarkGreen', IconCheckmarkGreenUrl);
const IconClose = makeSvg('IconClose', IconCloseUrl);
const IconCollapse = makeSvg('IconCollapse', IconCollapseUrl);
const IconCollege2 = makeSvg('IconCollege2', IconCollege2Url);
const IconCollege = makeSvg('IconCollege', IconCollegeUrl);
const IconCommunicationsActive = makeSvg('IconCommunicationsActive', IconCommunicationsActiveUrl);
const IconCommunicationsDefault = makeSvg(
  'IconCommunicationsDefault',
  IconCommunicationsDefaultUrl
);
const IconContactUsActive = makeSvg('IconContactUsActive', IconContactUsActiveUrl);
const IconContactUsDefault = makeSvg('IconContactUsDefault', IconContactUsDefaultUrl);
const IconDashboardActive = makeSvg('IconDashboardActive', IconDashboardActiveUrl);
const IconDashboardDefault = makeSvg('IconDashboardDefault', IconDashboardDefaultUrl);
const IconDelete = makeSvg('IconDelete', IconDeleteUrl);
const IconDownloadPrimaryBase = makeSvg('IconDownloadPrimaryBase', IconDownloadPrimaryBaseUrl);
const IconDownload = makeSvg('IconDownload', IconDownloadUrl);
const IconEdit = makeSvg('IconEdit', IconEditUrl);
const IconExit = makeSvg('IconExit', IconExitUrl);
const IconExpand = makeSvg('IconExpand', IconExpandUrl);
const IconGrip = makeSvg('IconGrip', IconGripUrl);
const IconHouseActive = makeSvg('IconHouseActive', IconHouseActiveUrl);
const IconHouseDefault = makeSvg('IconHouseDefault', IconHouseDefaultUrl);
const IconInvestment = makeSvg('IconInvestment', IconInvestmentUrl);
const IconLicenseActive = makeSvg('IconLicenseActive', IconLicenseActiveUrl);
const IconLicenseDefault = makeSvg('IconLicenseDefault', IconLicenseDefaultUrl);
const IconMembersActive = makeSvg('IconMembersActive', IconMembersActiveUrl);
const IconMembersDefaultWhite = makeSvg('IconMembersDefaultWhite', IconMembersDefaultWhiteUrl);
const IconMembersDefault = makeSvg('IconMembersDefault', IconMembersDefaultUrl);
const IconMembersLarge = makeSvg('IconMembersLarge', IconMembersLargeUrl);
const IconMinimize = makeSvg('IconMinimize', IconMinimizeUrl);
const IconNavAlertDefault = makeSvg('IconNavAlertDefault', IconNavAlertDefaultUrl);
const IconNavMenuDefault = makeSvg('IconNavMenuDefault', IconNavMenuDefaultUrl);
const IconOrganization = makeSvg('IconOrganization', IconOrganizationUrl);
const IconOrgPaysLarge = makeSvg('IconOrgPaysLarge', IconOrgPaysLargeUrl);
const IconOrgPaysTertiary = makeSvg('IconOrgPaysTertiary', IconOrgPaysTertiaryUrl);
const IconPaymentActive = makeSvg('IconPaymentActive', IconPaymentActiveUrl);
const IconPaymentDefault = makeSvg('IconPaymentDefault', IconPaymentDefaultUrl);
const IconProfile = makeSvg('IconProfile', IconProfileUrl);
const IconSearch = makeSvg('IconSearch', IconSearchUrl);
const IconStepper = makeSvg('IconStepper', IconStepperUrl);
const IconWarning = makeSvg('IconWarning', IconWarningUrl);
const IpmIconDelete = makeSvg('IpmIconDelete', IpmIconDeleteUrl);
const IpmIconDownload = makeSvg('IpmIconDownload', IpmIconDownloadUrl);
const LogoTextSecondaryUnregistered = makeSvg(
  'LogoTextSecondaryUnregistered',
  LogoTextSecondaryUnregisteredUrl
);
const NickelsULogoSecondary = makeSvg('NickelsULogoSecondary', NickelsULogoSecondaryUrl);
const PiggyBank = makeSvg('PiggyBank', PiggyBankUrl);
const Presents = makeSvg('Presents', PresentsUrl);
const Ribbon = makeSvg('Ribbon', RibbonUrl);
const SendArrow = makeSvg('SendArrow', SendArrowUrl);
const Umbrella = makeSvg('Umbrella', UmbrellaUrl);
const WebIconGrip = makeSvg('WebIconGrip', WebIconGripUrl);
const WebIconOrganization = makeSvg('WebIconOrganization', WebIconOrganizationUrl);
const WebIconRefresh = makeSvg('WebIconRefresh', WebIconRefreshUrl);

export const Svgs = {
  ActionSmallBank,
  ActionSmallCalendar,
  ActionSmallCloseDefault,
  ActionSmallEdit,
  ActionSmallEllipsis,
  ActionSmallEnvelopeTertiaryDefault,
  ActionSmallExportDefault,
  ActionSmallFilter,
  ActionSmallGrip,
  ActionSmallMenuClose,
  ActionSmallPhone2TertiaryDefault,
  ActionSmallPlus,
  ActionSmallPlusDisabled,
  ActionSmallScrollToBottom,
  ActionSmallSignOutTertiary,
  ActionAdviceIconDefault,
  ActionBudgetIconDefault,
  ActionGoalsIconDefault,
  ActionNetWorthIconDefault,
  ActionToolsIconDefault,
  AppleLogoWhite,
  Arrow,
  ArtAdvice,
  ArtApproved,
  ArtBooks,
  ArtBrainFog,
  ArtBusiness,
  ArtCar,
  ArtCar1,
  ArtCar2,
  ArtCarouselBeachChair,
  ArtCarouselBusiness,
  ArtCarouselCar,
  ArtCarouselCoinsDown,
  ArtCarouselCoinsSame,
  ArtCarouselCoinsUp,
  ArtCarouselCollege,
  ArtCarouselCompass,
  ArtCarouselCreditCard,
  ArtCarouselGifts,
  ArtCarouselGifts2,
  ArtCarouselGuitar,
  ArtCarouselHouse,
  ArtCarouselLoan,
  ArtCarouselMedical,
  ArtCarouselPaintbrush,
  ArtCarouselPool,
  ArtCarouselSailboat,
  ArtCarouselShopping,
  ArtCarouselWedding,
  ArtCarouselWheelBarrow,
  ArtCardBeachChair,
  ArtCardBonds,
  ArtCardCash,
  ArtCardClock,
  ArtCardCreditCard,
  ArtCardDebt,
  ArtCardMoney,
  ArtCardPiggyBank,
  ArtCardStocks,
  ArtCardTarget,
  ArtCoffee,
  ArtCellPhone,
  ArtChipCalculator,
  ArtChipCollege,
  ArtChipCreditCard,
  ArtChipPieChart,
  ArtCollegeGradCap,
  ArtComprehensiveInsurance,
  ArtCreditScore,
  ArtConfusedMan,
  ArtCreditCard,
  ArtCreditCard2,
  ArtCreditCard3,
  ArtDashboardChecklist,
  ArtDashboardLightbulb,
  ArtDashboardMagnifyingGlass,
  ArtDebtSmall,
  ArtDebt,
  ArtDonation,
  ArtGivingCollege,
  ArtGivingHeart2,
  ArtHandClap,
  ArtHandshake,
  ArtHealthInsurance,
  ArtHealthInsurance2,
  ArtHeart,
  ArtHouse,
  ArtHouseKeys,
  ArtHouseLarge,
  ArtInvestmentData,
  ArtLaptopLarge,
  ArtLaptop,
  ArtLifestyle,
  ArtLightbulbLarge,
  ArtLightbulbMedium,
  ArtLightbulbSmall,
  ArtMagnifyingGlass,
  ArtMedicalSupplies,
  ArtMeditation,
  ArtMoneyLarge,
  ArtMoneyPlant,
  ArtMoneySmall,
  ArtOrganization,
  ArtPieChart,
  ArtPieChartLarge,
  ArtPiggyBank2,
  ArtPiggyBank3,
  ArtPlant,
  ArtPresents,
  ArtQuestion,
  ArtPiggyBank,
  ArtRetirement,
  ArtRetirementLarge,
  ArtRetirementSmall,
  LinkPaperClip,
  LogoHeyNicIconOnly,
  LogoTithelyIconOnly,
  LogoTithely,
  ArtRibbon,
  ArtStudyMaterials,
  ArtTarget,
  ArtTargetSmall,
  ArtThumbsUp,
  ArtTrophySmall2,
  ArtUmbrella2,
  ArtUmbrella,
  ArtUni3N,
  BeachChair,
  BulletBook,
  BulletCalculator,
  BulletChecklist,
  BulletCoach,
  BulletInvestmentGC,
  BulletInvestment,
  BulletLessons,
  BulletLoans,
  BulletPiggyBank,
  BulletPiggyBankGc,
  BulletQa,
  BulletStatistics,
  Car,
  CardGradient,
  Cash,
  CollegeGradCap,
  Confetti,
  Debt,
  DisplayExtraSmallCustomCheckmark,
  DisplayExtraSmallCustomX,
  DisplayHamburgerMenuChatPrimary,
  DisplayHamburgerMenuChatSecondary,
  DisplayHamburgerMenuPremium,
  DisplayHamburgerMenuSignOut,
  DisplayHamburgerMenuSignOutPrimary,
  DisplayHamburgerMenuHeadset,
  DisplayHamburgerMenuHeadsetPrimary,
  DisplayLargeCustomCheckmark,
  DisplayLargeCustomClock,
  DisplayLargeCustomCollision3,
  DisplayLargeCustomHomeOffer,
  DisplayLargeCustomHomeSale,
  DisplayLargeCustomHouse,
  DisplayLargeCustomLegalDocs,
  DisplayLargeCustomMedical,
  DisplayLargeCustomMoneyBag,
  DisplayLargeCustomMoneyExchange,
  DisplayLargeCustomPaintRoller,
  DisplayLargeCustomRetirement,
  DisplayLargeCustomSaleProceeds,
  DisplayLargeCustomScale,
  DisplayLargeCustomTax,
  DisplayLargeCustomWarning,
  DisplayLargeCustomWarningErrorBase,
  DisplaySmallCustomXFilled,
  DisplayMediumCustomBirthdayCake,
  DisplayMediumCustomBriefcasePrimary,
  DisplayMediumCustomBriefcase,
  DisplayMediumCustomBus,
  DisplayMediumCustomCancel,
  DisplayMediumCustomCar,
  DisplayMediumCustomCarSecondary,
  DisplayMediumCustomCaution,
  DisplayMediumCustomCellPhone,
  DisplayMediumCustomCoffee,
  DisplayMediumCustomCreditCard,
  DisplayMediumCustomGender,
  DisplayMediumCustomGlass,
  DisplayMediumCustomHandshake,
  DisplayMediumCustomHeart,
  DisplayMediumCustomLightbulb,
  DisplayMediumCustomLocation,
  DisplayMediumCustomPlane,
  DisplayMediumCustomReceipt,
  DisplayMediumCustomRibbon,
  DisplayMediumCustomShoppingCart,
  DisplayMediumCustomSpeedometer,
  DisplayMediumCustomTV,
  DisplayMediumCustomUmbrella,
  DisplayMediumPrimaryAnotherBehalf,
  DisplayMediumPrimaryBudget,
  DisplayMediumPrimaryCar,
  DisplayMediumPrimaryCoins,
  DisplayMediumPrimaryCoinStack,
  DisplayMediumPrimaryCollege,
  DisplayMediumPrimaryCreditCard,
  DisplayMediumPrimaryDebt,
  DisplayMediumPrimaryGifts,
  DisplayMediumPrimaryGoals,
  DisplayMediumPrimaryHouse,
  DisplayMediumPrimaryInvestment,
  DisplayMediumPrimaryLegacy,
  DisplayMediumPrimaryLoans,
  DisplayMediumPrimaryMedical,
  DisplayMediumPrimaryPiggyBank,
  DisplayMediumPrimaryPlane,
  DisplayMediumPrimaryRetirement,
  DisplayMediumPrimaryTax,
  DisplayMediumPrimaryTime,
  DisplayMediumPrimaryUmbrella,
  DisplaySmallCreditCardGrayFilled,
  DisplaySmallCreditCardPrimaryBaseFilled,
  DisplaySmallCreditCardPrimaryLightFilled,
  DisplaySmallCreditCardPrimaryLightOutlined,
  DisplaySmallCustomAdvice,
  DisplaySmallCustomAlerts,
  DisplaySmallCustomBirthdayCake,
  DisplaySmallCustomBook,
  DisplaySmallCustomBudget,
  DisplaySmallCustomBudget2,
  DisplaySmallCustomBank,
  DisplaySmallCustomBriefcase,
  DisplaySmallCustomCalculator,
  DisplaySmallCustomCalendar,
  DisplaySmallCustomCar,
  DisplaySmallCustomChat,
  DisplaySmallCustomChatActive,
  DisplaySmallCustomChecklist,
  DisplaySmallCustomCheckmarkFilled,
  DisplaySmallCustomCheckmark,
  DisplaySmallCustomClock,
  DisplaySmallCustomCoins,
  DisplaySmallCustomCollision,
  DisplaySmallCustomCreditCard,
  DisplaySmallCustomCreditCardPrimary,
  DisplaySmallCustomCreditCard2,
  DisplaySmallCustomCreditCard3,
  DisplaySmallCustomDeposit,
  DisplaySmallCustomDebt,
  DisplaySmallCustomDebt2,
  DisplaySmallCustomDocUpload,
  DisplaySmallCustomEnvelope,
  DisplaySmallCustomFax,
  DisplaySmallCustomFood,
  DisplaySmallCustomFoodYellow,
  DisplaySmallCustomFunnel,
  DisplaySmallCustomGifts,
  DisplaySmallCustomGiftsPrimary,
  DisplaySmallCustomGoals,
  DisplaySmallCustomGoals2,
  DisplaySmallCustomHandshake,
  DisplaySmallCustomHealthInsurance,
  DisplaySmallCustomHeyNic,
  DisplaySmallCustomHomeSale,
  DisplaySmallCustomHouse,
  DisplaySmallCustomHouseAfford,
  DisplaySmallCustomHouseKeys,
  DisplaySmallCustomInfo,
  DisplaySmallCustomInstitution,
  DisplaySmallCustomInvestment,
  DisplaySmallCustomInvestment2,
  DisplaySmallCustomItemization,
  DisplaySmallCustomLegacy,
  DisplaySmallCustomLightBulb,
  DisplaySmallCustomLinkAccount,
  DisplaySmallCustomLoans,
  DisplaySmallCustomLoansSecondary,
  DisplaySmallCustomLock,
  DisplaySmallCustomLockGray,
  DisplaySmallCustomMarketplace,
  DisplaySmallCustomMedical,
  DisplaySmallCustomMedicalUmbrella,
  DisplaySmallCustomMembers,
  DisplaySmallCustomOnTarget,
  DisplaySmallCustomOrganization,
  DisplaySmallCustomPayOff,
  DisplaySmallCustomPercent,
  DisplaySmallCustomPhone2,
  DisplaySmallCustomPiggyBank,
  DisplaySmallCustomPlan,
  DisplaySmallCustomProfileActive,
  DisplaySmallCustomProfileDefault,
  DisplaySmallCustomProgressComplete,
  DisplaySmallCustomPromotions,
  DisplaySmallCustomRentOrBuy,
  DisplaySmallCustomRetirement,
  DisplaySmallCustomScale,
  DisplaySmallCustomSearch,
  DisplaySmallCustomShield,
  DisplaySmallCustomShoppingCart,
  DisplaySmallCustomStatistics,
  DisplaySmallCustomTax,
  DisplaySmallCustomThumbsDown,
  DisplaySmallCustomThumbsUp,
  DisplaySmallCustomTools,
  DisplaySmallCustomUmbrella,
  DisplaySmallCustomVacation,
  DisplaySmallCustomVideoCamera,
  DisplaySmallCustomWallet,
  DisplaySmallCustomWalletPrimary,
  DisplaySmallCustomWarning,
  DisplaySmallPrimaryLightBook,
  DisplaySmallPrimaryLightLock,
  DisplaySmallSecondaryBasePiggyBank,
  DisplaySmallWhiteBank,
  DisplaySmallWhiteBook,
  DisplaySmallWhiteBudget,
  DisplaySmallWhiteCar,
  DisplaySmallWhiteCoins,
  DisplaySmallWhiteCollege,
  DisplaySmallWhiteDeposit,
  DisplaySmallWhiteFood,
  DisplaySmallWhiteHandshake,
  DisplaySmallWhiteHealthInsurance,
  DisplaySmallWhiteHouse,
  DisplaySmallWhiteItemization,
  DisplaySmallWhiteLegacy,
  DisplaySmallWhiteLightBulb,
  DisplaySmallWhiteLoans,
  DisplaySmallWhiteMedical,
  DisplaySmallWhiteMembers,
  DisplaySmallWhitePlan,
  DisplaySmallWhiteRetirement,
  DisplaySmallWhiteShoppingCart,
  DisplaySmallWhiteVacation,
  DisplaySmallWhiteVideoCamera,
  DisplaySmallWhiteWallet,
  DisplaySmallWhiteWithdraw,
  DownArrowSecondary,
  GivingHeart,
  House,
  DisplaySmallCustomWithdraw,
  Icon3NUCoach,
  Icon3NULessons,
  Icon3NUQa,
  IconAdd,
  IconAdminsActive,
  IconAdminsDefault,
  IconArrowDown,
  IconArrowLeft,
  IconArrowLeftDisabled,
  IconArrowRight,
  IconArrowRightDisabled,
  IconArrowRightWhite,
  IconBook,
  IconCalculator,
  IconChat,
  IconChecklist,
  IconCheckmark,
  IconCheckmarkGreen,
  IconClose,
  IconCollapse,
  IconCollege2,
  IconCollege,
  IconCommunicationsActive,
  IconCommunicationsDefault,
  IconContactUsActive,
  IconContactUsDefault,
  IconDashboardActive,
  IconDashboardDefault,
  IconDelete,
  IconDownloadPrimaryBase,
  IconDownload,
  IconEdit,
  IconExit,
  IconExpand,
  IconGrip,
  IconHouseActive,
  IconHouseDefault,
  IconInvestment,
  IconLicenseActive,
  IconLicenseDefault,
  IconMembersActive,
  IconMembersDefaultWhite,
  IconMembersDefault,
  IconMembersLarge,
  IconMinimize,
  IconNavAlertDefault,
  IconNavMenuDefault,
  IconOrganization,
  IconOrgPaysLarge,
  IconOrgPaysTertiary,
  IconPaymentActive,
  IconPaymentDefault,
  IconProfile,
  IconSearch,
  IconStepper,
  IconWarning,
  IpmIconDelete,
  IpmIconDownload,
  LogoTextSecondaryUnregistered,
  NickelsULogoSecondary,
  PiggyBank,
  Presents,
  Ribbon,
  SendArrow,
  Umbrella,
  WebIconGrip,
  WebIconOrganization,
  WebIconRefresh,
};
